export const SalesTargetsColConfig = [
  {
    name_of_db_column: 'salesTargetName',
    label_of_column: 'Name',
    order_of_column: 1,
    columnFilterPlaceholder: 'Name'
  },
  {
    name_of_db_column: 'eligibleStoresCount',
    label_of_column: '# Eligible Stores',
    order_of_column: 2,
    columnFilterPlaceholder: '# Eligible Stores'
  },
  {
    name_of_db_column: 'percentTargetAchieved',
    label_of_column: '% Achieved Target',
    order_of_column: 3,
    columnFilterPlaceholder: '% Achieved Target'
  },
  {
    name_of_db_column: 'pointsAwarded',
    label_of_column: 'Points Awarded',
    order_of_column: 4,
    columnFilterPlaceholder: 'Points Awarded'
  },
  {
    name_of_db_column: 'startDate',
    label_of_column: 'Start Date',
    order_of_column: 5,
    filterVariant: 'dateRange',
    initialSize: 330,
    columnFilterPlaceholder: 'Start Date'
  },
  {
    name_of_db_column: 'endDate',
    label_of_column: 'End Date',
    order_of_column: 6,
    filterVariant: 'dateRange',
    initialSize: 330,
    columnFilterPlaceholder: 'End Date'
  },
  {
    name_of_db_column: 'status',
    label_of_column: 'Status',
    order_of_column: 7,
    initialSize: 330,
    columnFilterPlaceholder: 'Status'
  },
  {
    name_of_db_column: 'reportUrl',
    label_of_column: 'Report',
    order_of_column: 8,
    columnFilterPlaceholder: 'Report',
    filterable: false,
    hideSortIcon: true
  },
  {
    name_of_db_column: 'lastUpdatedDate',
    label_of_column: 'Last Updated',
    order_of_column: 9,
    filterVariant: 'dateRange',
    initialSize: 330,
    columnFilterPlaceholder: 'Last Updated'
  },
  {
    name_of_db_column: 'updatedBy',
    label_of_column: 'Updated By',
    order_of_column: 10,
    initialSize: 330,
    columnFilterPlaceholder: 'Updated By'
  }
];
